import type { AttachmentFullViewState } from "owa-attachment-full-data";
import { type AttachmentClass, isSmimeAttachmentType } from "owa-attachment-model-store";
import getAttachment from "owa-attachment-model-store/lib/selectors/getAttachment";
import type AttachmentWellViewState from "../schema/AttachmentWellViewState";

export default function getSavableClassicAttachments(attachmentWell: Pick<AttachmentWellViewState, "docViewAttachments" | "imageViewAttachments">): AttachmentFullViewState[] {
    return [...attachmentWell.docViewAttachments, ...attachmentWell.imageViewAttachments].filter(attachment => {
        const model = getAttachment(attachment.attachmentId);
        return (!attachment.isCloudy &&
            !!model?.info?.allowDownload &&
            model.attachmentClass !== 1 &&
            !isSmimeAttachmentType(model.model));
    });
}
